import {ACTION_CODE} from './_actionCode';
import {LocationService} from '../../services';
import {ErrorModel, ResultModel} from '../../models';
import {LoggerService} from '../../services';
const FUNCTION_CODE = 'UPDATE_LOCATION';

export async function updateLocation(
    userData: Record<string, any>,
    locationId: number,
    payloadUpdate: Record<string, any>
) {
    try {
        LoggerService.logInfo('Action - updateLocationById - Start');

        const updateLocationByIdResult =
            await LocationService.updateLocation(userData, locationId, payloadUpdate);

        LoggerService.logInfo('Action - updateLocationById - End - Success');

        return ResultModel.newSuccessResult(updateLocationByIdResult);
    }
    catch (error) {
        LoggerService.logInfo('Action - updateLocationById - End - Error');
        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Erreur de mise à jour d\'une banque',
            error: error
        });
        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}
